import { render, staticRenderFns } from "./onboardPayroll.vue?vue&type=template&id=a06ffd8a&scoped=true"
import script from "./onboardPayroll.vue?vue&type=script&lang=js"
export * from "./onboardPayroll.vue?vue&type=script&lang=js"
import style0 from "./onboardPayroll.vue?vue&type=style&index=0&id=a06ffd8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06ffd8a",
  null
  
)

export default component.exports